import React from "react";
import styled from "styled-components";
import SearchSelectBox from "./SearchSelectBox";
// import { useRecoilState } from "recoil";
// import { searchCmpBox } from "../../recoilatoms/searchCmp";
import { Input } from "antd";

const AdminBoardSearchInner = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;

const AdminBoardSearch = styled.div`
  width: 40%;
  display: flex;
  align-items: center;
  margin-top: 10px;
`;

const SearchInput = ({ onSearchHandler }) => {
  // console.log(onSearch);
  const { Search } = Input;
  // const [searchCmp, setSearchCpm] = useRecoilState(searchCmpBox);

  function handleInputChange(text) {
    // console.log(text.target.value);
    console.log("text", text);
    onSearchHandler(text);
  }
  return (
    <AdminBoardSearchInner>
      <AdminBoardSearch>
        <SearchSelectBox />
        <Search placeholder="search text" allowClear enterButton="Search" size="large" onSearch={handleInputChange} />
      </AdminBoardSearch>
    </AdminBoardSearchInner>
  );
};

export default SearchInput;
